import "core-js/modules/es6.array.map.js";
import { extractCategoryHash } from '~/helpers/extract-helper';
export default {
  type: 'offer',
  aliases: ['offer'],
  slices: [{
    name: 'offer_header',
    path: 'Offer/OfferHeader.vue'
  }, {
    name: 'offer_inspirations',
    path: 'Offer/OfferInspirations.vue'
  }, {
    name: 'offer_chips',
    path: 'Global/GlobalChips.vue'
  }, {
    name: 'offer_carousel',
    path: 'Global/GlobalCategoryProductsCarousel.vue',
    additional: {
      query: 'category',
      handler: function handler(arg) {
        return {
          filterBy: [],
          sortBy: 'POPULAR',
          orderBy: 'DEFAULT',
          hash: extractCategoryHash(arg.primary.button_url.url),
          offset: arg.primary.from,
          limit: arg.primary.size,
          enableRating: false
        };
      }
    }
  }, {
    name: 'eb_products_carousel',
    path: 'Global/ProductsCarouselEb.vue'
  }, {
    name: 'offer_footer',
    path: 'Global/GlobalDispatchFooter.vue'
  }, {
    name: 'collection_banner',
    path: 'Collection/CollectionBanner.vue'
  }, {
    name: 'tag_list_block',
    path: 'Global/TagListBlock.vue',
    additional: {
      query: 'categories',
      handler: function handler(arg) {
        return {
          hashes: arg.items.map(function (e) {
            return e.hash;
          })
        };
      }
    }
  }, {
    name: 'tag_list_image',
    path: 'Global/TagListImage.vue',
    additional: {
      query: 'categories',
      handler: function handler(arg) {
        return {
          hashes: arg.items.map(function (e) {
            return e.hash;
          })
        };
      }
    }
  }]
};